var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',{staticStyle:{"margin-top":"0"}},[_c('div',{staticClass:"grid grid--middle"},[_c('div',{staticClass:"grid__cell col4-of-12--medium-up"},[_c('Input',{attrs:{"label":"Status","type":"select","selected":_vm.profileData.status,"showDefaultOption":false,"options":[
            {
              name: 'Public',
              value: 'P',
            },
            {
              name: 'Public - show when no results',
              value: 'G',
            },
            {
              name: 'Public - Featured',
              value: 'F',
            },
            {
              name: 'Searchable',
              value: 'S',
            },
            {
              name: 'Hidden',
              value: 'H',
            } ]},on:{"input-change":function($event){return _vm.handleChange($event, 'updateStatus')}}})],1),_c('div',{staticClass:"grid__cell col4-of-12--medium-up"},[_c('Input',{attrs:{"label":"Featured","type":"select","showDefaultOption":false,"selected":_vm.profileData.featured,"disabled":_vm.OPP || _vm.profileData.status === 'H',"options":[
            {
              name: 'No',
              value: false,
            },
            {
              name: 'Yes',
              value: true,
            } ]},on:{"input-change":function($event){return _vm.handleChange($event, 'updateFeatured')}}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }